import { Timestamp } from "firebase/firestore"
import { formatDate, formatTime, toDate } from "utils/dateFormat"

/**
 * Timestamp to date and time.
 * 
 * @param timestamp to be converted
 * 
 * @returns date and time
 */
export const timestampToDate = (timestamp: String | undefined | Timestamp): string[] => {
    const value = typeof timestamp === 'string' || timestamp instanceof String
        ? String(timestamp)
        : timestamp
    const date = toDate(value)
    if (!date) return ['', '']
    return [formatDate(date), formatTime(date)]
}

/**
 * Convert string into a slug.
 * 
 * @param str to be converted
 * 
 * @returns converted string
 */
export const stringToSlug = (str: string): string => {
    return str.toLowerCase().replace(/ /g, '-')
}

/**
 * Convert text into html.
 * 
 * @param text to be converted
 * 
 * @returns converted text
 */
export const textToHTML = (text: string): string => {
    return text.replace(/\n/g, '<br>')
}